import {Form, Input, Space, Button, message, Spin, Card, Typography, Alert} from "antd";
import React, {useEffect, useState}  from "react";
import {useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import {CloseOutlined, SaveOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

const { Title, Text } = Typography;

const FormChangePassword = () => {

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      };

    const [messageApi, contextHolder] = message.useMessage();

    const [spinning, setSpinning] = useState(false);
    const [canSubmit, setCanSubmit] = useState(false);

    const spinTitle = <FormattedMessage id="progress_cambiar_password" defaultMessage="Cambiando contraseña..." />;

    let infor_user = (sessionStorage.getItem('info_user'))? JSON.parse(sessionStorage.getItem('info_user')):null;

    const navigate = useNavigate();

    const { id } = useParams();

    const [form] = Form.useForm();

    useEffect(() => {
        if(id !== infor_user.idusuario)
               navigate('/principal');

    }, [id, infor_user.idusuario, navigate]);

    // Función para validar si se puede enviar el formulario
    const validateForm = (allValues) => {
        const { contrasenna, confirm } = allValues;

        // Verificar que ambos campos estén llenos
        if (!contrasenna || !confirm) {
            setCanSubmit(false);
            return;
        }

        // Verificar que la contraseña tenga al menos 8 caracteres
        if (contrasenna.length < 8) {
            setCanSubmit(false);
            return;
        }

        // Verificar que la contraseña cumpla con el patrón (mayúscula, minúscula, número)
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]/;
        if (!passwordPattern.test(contrasenna)) {
            setCanSubmit(false);
            return;
        }

        // Verificar que las contraseñas coincidan
        if (contrasenna !== confirm) {
            setCanSubmit(false);
            return;
        }

        // Si todo está correcto, habilitar el botón
        setCanSubmit(true);
    };

    const cancelar = () => {
        navigate('/principal');
    };

    const onFinish = (values) => {
        setSpinning(true);
        Axios.post("mts/changePasswordUsser",
            {
              "idusuario": id,
              "contrasenna": values.contrasenna,
            },
            {
                headers: headers
              }
          ).then(response => {
             setSpinning(false);
             if(response.data.success){
                messageApi.open({
                    type: 'success',
                    content: <FormattedMessage id="message_save_information" defaultMessage="Se ha guardado la infomación correctamente." />,
                    duration: 0,
                });

                setTimeout(messageApi.destroy, 2500);
                navigate('/principal');
            }else{
                messageApi.open({
                    type: 'error',
                    content: <FormattedMessage id="message_error_save_information" defaultMessage="Error al guardar la información." />,
                    duration: 0,
                });

                setTimeout(messageApi.destroy, 2500);
            }
        })
        .catch(() => {
            setSpinning(false);
            messageApi.open({
                type: 'error',
                content: <FormattedMessage id="message_error_save_information" defaultMessage="Error al guardar la información." />,
                duration: 0,
            });

            setTimeout(messageApi.destroy, 2500);
        });

      };


      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "24px",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <div style={{
                    maxWidth: "600px",
                    width: "100%"
                }}>
                    {/* Header */}
                    <div style={{
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '32px',
                        color: 'white',
                        textAlign: 'center'
                    }}>
                        <div style={{
                            background: 'rgba(255,255,255,0.2)',
                            borderRadius: '50%',
                            width: '64px',
                            height: '64px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '24px',
                            margin: '0 auto 16px'
                        }}>
                            <LockOutlined />
                        </div>
                        <Title level={2} style={{
                            color: 'white',
                            margin: 0,
                            fontSize: '24px'
                        }}>
                            Cambiar Contraseña
                        </Title>
                        <Text style={{
                            color: 'rgba(255,255,255,0.8)',
                            fontSize: '14px',
                            display: 'block',
                            marginTop: '8px'
                        }}>
                            Actualiza tu contraseña para mantener tu cuenta segura
                        </Text>
                    </div>

                    {/* Form Content */}
                    <Card style={{
                        borderRadius: '0 0 12px 12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        border: 'none'
                    }}>
                        {contextHolder}

                        {/* Security Notice */}
                        <Alert
                            message="Requisitos de Seguridad"
                            description="Tu nueva contraseña debe tener al menos 8 caracteres y ser diferente a tu contraseña actual."
                            type="info"
                            showIcon
                            style={{
                                marginBottom: '24px',
                                borderRadius: '8px',
                                border: '1px solid #e0e6ff'
                            }}
                        />
                        <Form
                            form={form}
                            autoComplete="on"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            layout="vertical"
                            name="form_change_password"
                            size="large"
                            onValuesChange={(changedValues, allValues) => {
                                validateForm(allValues);
                            }}
                        >


                            <Form.Item
                                name="contrasenna"
                                label={
                                    <span style={{ fontWeight: '500', color: '#253289' }}>
                                        Nueva Contraseña
                                    </span>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor ingresa tu nueva contraseña',
                                    },
                                    {
                                        min: 8,
                                        message: 'La contraseña debe tener al menos 8 caracteres'
                                    },
                                    {
                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]/,
                                        message: 'Debe contener al menos una mayúscula, una minúscula y un número'
                                    }
                                ]}
                                hasFeedback
                            >
                                <Input.Password
                                    placeholder="Ingresa tu nueva contraseña"
                                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                    style={{
                                        borderRadius: '8px',
                                        border: '1px solid #e0e6ff'
                                    }}
                                />
                            </Form.Item>

                            <Form.Item
                                name="confirm"
                                label={
                                    <span style={{ fontWeight: '500', color: '#253289' }}>
                                        Confirmar Nueva Contraseña
                                    </span>
                                }
                                dependencies={['contrasenna']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor confirma tu nueva contraseña',
                                    },
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('contrasenna') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Las contraseñas no coinciden'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password
                                    placeholder="Confirma tu nueva contraseña"
                                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                    style={{
                                        borderRadius: '8px',
                                        border: '1px solid #e0e6ff'
                                    }}
                                />
                            </Form.Item>

                            {/* Action Buttons */}
                            <div style={{
                                textAlign: "center",
                                paddingTop: '24px',
                                borderTop: '1px solid #f0f0f0',
                                marginTop: '32px'
                            }}>
                                <Space size="large">
                                    <Button
                                        icon={<CloseOutlined/>}
                                        onClick={cancelar}
                                        size="large"
                                        style={{
                                            height: '48px',
                                            paddingLeft: '32px',
                                            paddingRight: '32px',
                                            fontWeight: '500',
                                            borderRadius: '8px',
                                            border: '1px solid #ff4d4f',
                                            color: '#ff4d4f'
                                        }}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        icon={<SaveOutlined/>}
                                        type="primary"
                                        htmlType="submit"
                                        size="large"
                                        disabled={!canSubmit}
                                        style={{
                                            background: canSubmit
                                                ? 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)'
                                                : '#d9d9d9',
                                            borderColor: canSubmit ? '#253289' : '#d9d9d9',
                                            height: '48px',
                                            paddingLeft: '32px',
                                            paddingRight: '32px',
                                            fontWeight: '500',
                                            borderRadius: '8px',
                                            boxShadow: canSubmit
                                                ? '0 2px 8px rgba(37, 50, 137, 0.3)'
                                                : 'none',
                                            color: canSubmit ? 'white' : '#000000'
                                        }}
                                    >
                                        Actualizar Contraseña
                                    </Button>
                                </Space>
                            </div>
                        </Form>
                    </Card>
                </div>
            </Spin>
        </div>

    );
};

export default FormChangePassword;